import { Aperture, BookOpen, Codepen, FileText, Youtube } from "react-feather";

export const ARTICALS_DATA = [
  {
    id: 1,
    title: "Articles",
    paragraph: "How little experience or technical knowledge you currently have. The web is a very big place, and if you are the typical internet user, you probably visit several websites every day.",
    icon: <BookOpen />,
    class: "col-xl-4 xl-100 box-col-12",
    sm: "6",
  },
  {
    id: 2,
    title: "Knowledgebase",
    paragraph: "A Website Designing course enables learners to use essential designing and programming tools required to do the job efficiently. The curriculum is a blend of various themes.",
    icon: <Aperture />,
    class: "col-xl-4 xl-50 col-md-6 box-col-6",
    sm: "6",
  },
  {
    id: 3,
    title: "Support",
    paragraph: "The customer support industry is renaissance. Customer support as a specialty is coming into its own, offering companies a competitive advantage that’s difficult to copy.",
    icon: <FileText />,
    class: "col-xl-4 xl-50 col-md-6 box-col-6",
    class2: "col-md-6 box-col-4",
  },
];

export const KNOWLEDGEBASE_DATA = [
  {
    id: 1,
    title: "Any other legal pages I should know about?",
    knowledgeList: [
      {
        text: "Policies have wide acceptance among editors",
        fileTextIcon: true,
      },
      {
        text: "Guidelines are sets of best practices supported.",
        badge: "New",
        fileTextIcon: true,
      },
      {
        fileTextIcon: true,
        text: "Editors should attempt to follow guidelines.",
      },
      {
        fileTextIcon: true,
        text: "They are best treated with common sense.",
      },
      {
        text: "See More (40)",
      },
    ],
  },
  {
    id: 2,
    title: "Does Moment have an API or automatic export?",
    knowledgeList: [
      {
        text: "Resource API content produced by business.",
        fileTextIcon: true,
        badge: "Review",
      },
      {
        fileTextIcon: true,
        text: "API allows the search and download of AP Images.",
      },
      {
        fileTextIcon: true,
        text: "API retrieve a list of breaking news categories",
        badge: "Articles",
      },
      {
        fileTextIcon: true,
        text: "API retrieves rules for a fantasy league.",
      },
      {
        text: "See More (90)",
      },
    ],
  },
  {
    id: 3,
    title: "WordPress Site Maintenance",
    knowledgeList: [
      {
        fileTextIcon: true,
        text: "Make a backup of your WordPress website.",
      },
      {
        fileTextIcon: true,
        text: "Run a security check.",
        badge: "Closed",
      },
      {
        fileTextIcon: true,
        text: "Monitor your search engine optimization.",
      },
      {
        fileTextIcon: true,
        text: "Set a regular maintenance schedule.",
      },
      {
        text: "See More (50)",
      },
    ],
  },
  {
    id: 4,
    title: "Can I change my plan later?",
    knowledgeList: [
      {
        text: "You can easily change plans Wonderfull at any time.",
        fileTextIcon: true,
        badge: "Popular",
      },
      {
        fileTextIcon: true,
        text: "you’ll be charged a prorated cover that upgrade.",
      },
      {
        fileTextIcon: true,
        text: "Sed quia non numquam eius modi tempora incidunt",
      },
      {
        fileTextIcon: true,
        text: "But also the leap into electronic typesetting,",
      },
      {
        text: "See More (90)",
      },
    ],
  },
  {
    id: 5,
    title: "How do I pay for the Premium Plan?",
    knowledgeList: [
      {
        text: "Premium plans are billed as a yearly payment.",
        fileTextIcon: true,
      },
      {
        text: "Etraset sheets containing Lorem Ipsum passages",
        fileTextIcon: true,
      },
      {
        text: "You can set Monthly or Yearly for Premium plan.",
        fileTextIcon: true,
      },
      {
        fileTextIcon: true,
        text: "When an unknown printer took a galley",
        badge: "Closed",
      },
      {
        text: "See More (50)",
      },
    ],
  },
  {
    id: 6,
    title: "What is your Shopping Policy",
    knowledgeList: [
      {
        fileTextIcon: true,
        text: "Many new editors rely on policy interpretations.",
      },
      {
        fileTextIcon: true,
        text: "It has a more-or-less normal distribution of letters",
      },
      {
        text: "Violation of maintaining a neutral point of view.",
        fileTextIcon: true,
        badge: "Article",
      },
      {
        fileTextIcon: true,
        text: "You double check your sources.",
      },
      {
        text: "See More (26)",
      },
    ],
  },
  {
    id: 7,
    title: "Validating a Website",
    knowledgeList: [
      {
        text: "When our power of choice is untrammelled",
        fileTextIcon: true,
        badge: "Review",
      },
      {
        fileTextIcon: true,
        text: "It will frequently occur that pleasures",
      },
      {
        text: "who fail in their duty through weakness",
        fileTextIcon: true,
        badge: "Closed",
      },
      {
        fileTextIcon: true,
        text: " At vero eos et accusamus et iusto",
      },
      {
        text: "See More (10)",
      },
    ],
  },
  {
    id: 8,
    title: "How can I change the component?",
    knowledgeList: [
      {
        fileTextIcon: true,
        text: "You can modify some specific component settings.",
      },
      {
        text: "Click Apply to validate the set preferences.",
        fileTextIcon: true,
        badge: "Popular",
      },
      {
        text: "Following procedure applie to external components",
        fileTextIcon: true,
        badge: "Review",
      },
      {
        text: "To modify those specific components settings.",
        fileTextIcon: true,
      },
      {
        text: "See More (21)",
      },
    ],
  },
  {
    id: 9,
    title: "What is Lorem Ipsum?",
    knowledgeList: [
      {
        text: "Common language regular the existing languages.",
        fileTextIcon: true,
      },
      {
        text: "Lorem Ipsum been industry's standard dummy",
        fileTextIcon: true,
      },
      {
        text: "Language is not real even ‘Lorem’ does't exist.",
        fileTextIcon: true,
      },
      {
        text: "dummy text that is not meant to mean anything.",
        badge: "On hold",
        fileTextIcon: true,
      },
      {
        text: "See More (34)",
      },
    ],
  },
];

export const FEATURES_DATA = [
  {
    id: 1,
    img: "faq/1.jpg",
    date: "15 April 2023",
    writer: "Admin",
    hits: "0",
    short_description: [" Web Designing course belongs to the field of Computer Science and IT. It enables students to learn."],
    rvalue: 4,
    title: "Web Design",
  },
  {
    id: 2,
    img: "faq/2.jpg",
    date: "15 May 2023",
    writer: "Admin",
    hits: "0",
    short_description: ["This course is designed to start you on a path toward future studies in web development and design."],
    rvalue: 5,
    title: "Web Development",
  },
  {
    id: 3,
    img: "faq/3.jpg",
    date: "15 June 2023",
    writer: "Admin",
    hits: "0",
    short_description: ["User interface design (UI) is the design for machines and software, such as mobile devices, computers."],
    rvalue: 4,
    title: "UI Design",
  },
  {
    id: 4,
    img: "faq/4.jpg",
    date: "15 July 2023",
    writer: "Admin",
    hits: "0",
    short_description: ["A Web Designing course belongs to the field of Computer Science and IT. It enables students to learn."],
    rvalue: 3,
    title: "Tailwind Design",
  },
];

export const ARTICAL_AND_VIDEO_1 = [
  {
    iconClass: <Codepen className="m-r-30" />,
    title: "Article Base Video",
    description: "The web is a very big place, and if you are the typical internet base user.",
  },
  {
    iconClass: <Codepen className="m-r-30" />,
    title: "Knows your sources",
    description: "A book giving information on many subjects or on many aspects of one subject.",
  },
  {
    iconClass: <Codepen className="m-r-30" />,
    title: "Sources credible/reliable",
    description: "Simple demos of frequently asked questions about using the Libraries and information resources",
  },
];

export const ARTICAL_AND_VIDEO_2 = [
  {
    iconClass: <FileText className="m-r-30" />,
    title: "Validate website",
    description: "Website is the process of ensuring that the pages on the website conform.",
  },
  {
    iconClass: <FileText className="m-r-30" />,
    title: "Tailwind Design",
    description: "Tailwind is so low-level, it never encourages you to design the same site twice.",
  },
  {
    iconClass: <FileText className="m-r-30" />,
    title: "Knows your sources",
    description: "A book giving information on many subjects or on many aspects of one subject.",
  },
];

export const ARTICAL_AND_VIDEO_3 = [
  {
    iconClass:<Youtube className="m-r-30" />,
    title: "Sources Demos",
    description: "Simple demos of frequently asked questions about using the information resources.",
    md:"6",
  },
  {
    iconClass:<Youtube className="m-r-30" />,
    title: "Validate Html",
    description: "Website is the process of ensuring that the pages on the website conform.",
    md:"6",
  },
  {
    iconClass: <Youtube className="m-r-30" />,
    title: "Web Design",
    description: "Web is so high-level, it never encourages you to design the same site twiceCras dapibus.",
  },
];